<template>
  <div class="video-fullscreen">
    <!-- Close -->
    <div
      v-show="show"
      class="video-fullscreen__close"
      @click.stop="closeVideo"
    >
      <i class="icon-close"><span class="path1" /><span class="path2" /></i>
    </div>

    <!-- Video -->
    <div
      :id="id"
      :class="{ 'video-fullscreen__video--active': show }"
      class="video-fullscreen__video"
      :data-vimeo-id="videoId"
      data-vimeo-width="100%"
      data-vimeo-height="100%"
      data-vimeo-defer
    />
  </div>
</template>

<script>
import uid from '@/mixins/uid';
import keyboard from '@/mixins/keyboard';

export default {
  name: 'VideoFullscreen',

  mixins: [uid, keyboard],

  props: {
    videoId: {
      type: String,
      required: true
    },

    fullscreen: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      show: false,

      player: null
    };
  },

  watch: {
    fullscreen(value) {
      if (!value) {
        this.closeVideo();
        return;
      }

      if (this.player === null) {
        this.loadVideo();
      } else {
        this.playVideo();
      }
    }
  },

  methods: {
    closeVideo() {
      this.player.setCurrentTime(0);
      this.player.pause();

      this.show = false;

      this.$emit('stop-loading');
      this.$emit('close-fullscreen');
    },

    loadVideo() {
      // Setup player
      // id: this.videoId,
      /* eslint-disable no-undef */
      this.player = new Vimeo.Player(this.id, {
        url: this.videoId,
        autoplay: true
      });
      /* eslint-enable no-undef */
      // Adjust height/width on load
      this.player.on('loaded', () => {
        const frame = document.getElementById(this.id).querySelector('iframe');

        if (frame !== null) {
          frame.style.width = '100%';
          frame.style.height = '100%';
        }

        this.playVideo();
      });

      this.player.on('play', () => {
        this.$emit('stop-loading');
      });

      this.player.on('ended', () => {
        this.show = false;

        this.$emit('close-fullscreen');
      });
    },

    playVideo() {
      this.show = true;
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/video/video-fullscreen-view.scss"></style>



// WEBPACK FOOTER //
// video-fullscreen-view.vue